<!-- <div *ngIf="ngxChart?.dataLabelArray.length > 0; else nodata" style="width: 100%;"> -->
<div style="width: 100%">
  <plotly-plot
    [data]="plotlyChart.dataChart"
    [layout]="plotlyChart.layoutChart"
  >
  </plotly-plot>
  <!-- <canvas
    baseChart 
    [type]="ngxChart?.type"
    [datasets]="ngxChart?.dataSetArray"
    [labels]="ngxChart?.dataLabelArray"
    [colors]="lineChartColors"
    [options]="chartOptions"
    [legend]="legend">
  </canvas> -->
  <canvas
    baseChart
    [type]="ngxChart?.type"
    [datasets]="ngxChart?.dataSetArray"
    [labels]="ngxChart?.dataLabelArray"
    [options]="chartOptions"
    [legend]="legend"
  >
  </canvas>
</div>
<ng-template #nodata>
  <div class="container mtop5">
    <div class="text-center">
      <div class="">
        <i class="material-icons biggerIcon">not_interested</i>
      </div>
    </div>
    <div class="text-center">
      <div>
        <h3>{{ "WARNING_MESSAGES.NO_DATA_GRAPHIC" | translate }}.</h3>
        {{ "WARNING_MESSAGES.NO_DATA_PARAMS" | translate }}
      </div>
    </div>
  </div>
</ng-template>
